
import { BASE_URL } from "../../helpers/config";
import { showToast, showAlert } from "../../utils/helpers/ShowToast";
import authorizedAxios from "../../helpers/authorizedAxios";
export const SET_PURCHASES = "SET_PURCHASES";
export const SET_PURCHASES_LOADING = "SET_PURCHASES_LOADING";
export const SET_PURCHASES_ERROR = "SET_PURCHASES_ERROR";

export const fetchPurchases = (limit = 100, page = 1, search = "", status = "", filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_PURCHASES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/purchases", {
        params: {
          limit,
          page,
          search,
          status: status || undefined,
          start_date: filters?.start_date || undefined,
          end_date: filters?.end_date || undefined,
        },
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PURCHASES,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PURCHASES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PURCHASES_LOADING, status: false });
    }
  };
};

export const getPurchaseById = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_PURCHASES_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/purchases/" + id);

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_PURCHASES,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PURCHASES_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_PURCHASES_LOADING, status: false });
    }
  };
};
export const addPurchase = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PURCHASES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/purchases`, data), {
        loading: "Menyimpan data...",
        success: "Data purchase berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data purchase/pembelian berhasil ditambahkan!"
        });
        return true;
      }

      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PURCHASES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PURCHASES_LOADING, status: false });
    }
  };
};
export const updatePurchase = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_PURCHASES_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/purchases/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data purchase berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data purchase berhasil diupdate!"
        });
        return true;
      }

      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PURCHASES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PURCHASES_LOADING, status: false });
    }
  };
};
export const settlePurchase = (id, data, options = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_PURCHASES_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/purchases/payment/${id}`, data), {
        loading: "Memproses pelunasan...",
        success: "Pelunasan purchase berhasil disimpan!",
        error: (err) => err?.response?.data?.message || "Gagal memproses pelunasan!"
      });
      if (response.status === 200 || response.status === 201) {
        if (options?.refreshPurchases !== false) {
          await dispatch(fetchPurchases());
        }

        return true;
      }

      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PURCHASES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PURCHASES_LOADING, status: false });
    }
  };
};
export const deletePurchase = (id, reason, options = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_PURCHASES_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/purchases/${id}`, { data: { reason } }), {
        loading: "Membatalkan pembelian...",
        success: "Pembelian berhasil dibatalkan!",
        error: (err) => err?.response?.data?.message || "Gagal membatalkan pembelian!"
      });
      if (response.status === 200 || response.status === 201) {
        if (options?.refreshPurchases !== false) {
          await dispatch(fetchPurchases());
        }
        return true;
      }

      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_PURCHASES_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_PURCHASES_LOADING, status: false });
    }
  };
};
